module.exports = __webpack_public_path__ + "static/media/assessment-end-screen-vertical-line.2a63d5d5.png";